module.exports = "build/assets/mobileGrandpa.0737e8b9.png";